import { useEffect, useState } from "react";

import { HTTP_METHOD, POST_FIND_USER_BASIC } from "constants/pathConstant";
import { useMutationCustom } from "hooks/useMutationCustom";
import { useToastCustom } from "hooks/useToastCustom";
import { Search, Wrapper } from "template/SearchTemplate.style";
import { PLACEHOLDER } from "constants/baseStyle";

// 회원검색 :: 회원 조회 (http://localhost:3000/manage/user)
export const UserSearch = ({
  setUserMoveList,
  setPage,
  currentPage,
  pageSize,
  setSearchData,
  searchData,
}) => {
  const toast = useToastCustom();

  const [acctNm, setAcctNm] = useState("");
  const [acctCd, setAcctCd] = useState("");

  const { mutate } = useMutationCustom(POST_FIND_USER_BASIC, HTTP_METHOD.POST);

  useEffect(() => {
    if (!Object.keys(searchData)[0]) return;

    const researchCond = { ...searchData, pageSize, currentPage };

    setSearchData(researchCond);

    mutate(researchCond, {
      onSuccess: (data) => {
        setUserMoveList(data);
      },
    });
  }, [currentPage, pageSize]);

  const handleSearch = (acctNm, acctCd) => {
    setPage(1);

    const data = { acctNm, acctCd, pageSize, currentPage };

    setSearchData(data);

    mutate(data, {
      onSuccess: (data) => {
        setUserMoveList(data);
      },

      onError: () => {
        toast("조회 실패", "error");
      },
    });
  };

  const handleEnter = (key) => {
    if (key === "Enter") handleSearch(acctNm, acctCd);
  };

  return (
    <Wrapper>
      <Search.Text>회원 조회</Search.Text>
      <Search.Container>
        <Search.Content>
          <Search.InputWrapper>
            <div>회원명</div>
            <Search.Input
              placeholder={PLACEHOLDER.ALL}
              onChange={(e) => setAcctNm(e.target.value)}
              onKeyUp={(e) => handleEnter(e.key)}
            ></Search.Input>
          </Search.InputWrapper>
          <Search.InputWrapper>
            <div>회원코드</div>
            <Search.Input
              placeholder={PLACEHOLDER.SOME}
              onChange={(e) => setAcctCd(e.target.value)}
              onKeyUp={(e) => handleEnter(e.key)}
            ></Search.Input>
          </Search.InputWrapper>
        </Search.Content>
        <Search.Btn onClick={() => handleSearch(acctNm, acctCd)}>
          조회
        </Search.Btn>
      </Search.Container>
    </Wrapper>
  );
};
